import { scheduleAsyncPull, schedulePull } from './scheduling.js';
import { isRelay } from './reactive.js';
import { getCurrentConsumer } from './consumer.js';
export function dirtySignal(signal) {
    const prevState = signal._state;
    if (prevState === 2 /* ReactiveFnState.Dirty */) {
        return;
    }
    signal._state = 2 /* ReactiveFnState.Dirty */;
    if (prevState < 3 /* ReactiveFnState.MaybeDirty */) {
        propagateDirty(signal);
    }
}
function propagateDirty(signal) {
    if (getCurrentConsumer() === signal) {
        throw new Error('A signal was dirtied after it was consumed by the current function. This can cause race conditions and infinite rerenders and is not allowed.');
    }
    if (isRelay(signal)) {
        if (signal.watchCount > 0) {
            scheduleAsyncPull(signal);
        }
        // else do nothing, only schedule if connected
    }
    else {
        if (signal._isListener && signal.watchCount > 0) {
            schedulePull(signal);
        }
        dirtySignalConsumers(signal.subs);
        signal.subs.clear();
    }
}
export function dirtySignalConsumers(map) {
    for (const [subRef, edge] of map) {
        const sub = subRef.deref();
        if (sub === undefined || sub.computedCount !== edge.consumedAt)
            continue;
        const dirtyState = sub._state;
        switch (dirtyState) {
            case 0 /* ReactiveFnState.Clean */:
                sub._state = 3 /* ReactiveFnState.MaybeDirty */;
                sub.dirtyHead = edge;
                edge.nextDirty = undefined;
                propagateDirty(sub);
                break;
            case 1 /* ReactiveFnState.Pending */:
            case 3 /* ReactiveFnState.MaybeDirty */:
            case 4 /* ReactiveFnState.PendingDirty */: {
                let subEdge = sub.dirtyHead;
                const ord = edge.ord;
                if (subEdge.ord > ord) {
                    sub.dirtyHead = edge;
                    edge.nextDirty = subEdge;
                    if (dirtyState === 1 /* ReactiveFnState.Pending */ || dirtyState === 4 /* ReactiveFnState.PendingDirty */) {
                        // If the signal is pending, the first edge is the halt edge. If the
                        // new dirty edge is BEFORE the halt edge, then it means that something
                        // changed before the current halt, so we need to cancel the current computation
                        // and recompute.
                        sub._state = 3 /* ReactiveFnState.MaybeDirty */;
                        propagateDirty(sub);
                    }
                }
                else {
                    let nextDirty = subEdge.nextDirty;
                    while (nextDirty !== undefined && nextDirty.ord < ord) {
                        subEdge = nextDirty;
                        nextDirty = subEdge.nextDirty;
                    }
                    if (IS_DEV && edge === nextDirty) {
                        throw new Error('Edge already inserted, this should not happen. Please open an issue on GitHub.');
                    }
                    edge.nextDirty = nextDirty;
                    subEdge.nextDirty = edge;
                }
                break;
            }
        }
    }
}
